if (!customElements.get('collection-load-more')) {
  customElements.define(
    'collection-load-more',
    class CollectionLoadMore extends HTMLElement {
      constructor() {
        super();
        this.onLoadMore = this.onLoadMore.bind(this);
      }

      connectedCallback() {
        this.button = this.querySelector('[data-load-more]');
        if (this.button) {
          this.button.addEventListener('click', this.onLoadMore);
        }
      }

      disconnectedCallback() {
        if (this.button) {
          this.button.removeEventListener('click', this.onLoadMore);
        }
      }

      updateStatusText() {
        const statusEl = this.querySelector('[data-load-more-status]');
        if (!statusEl) return;

        const template = this.dataset.resultsTemplate || 'Viewing [loaded] - [total] results';
        const loaded = this.dataset.loadedCount || '0';
        const total = this.dataset.total || '0';

        statusEl.textContent = template
          .replace(/\[loaded\]/g, loaded)
          .replace(/\[total\]/g, total)
          .replace(/\[start\]/g, loaded)
          .replace(/\[end\]/g, total);
      }

      setLoading(isLoading) {
        if (!this.button) return;
        this.button.disabled = isLoading;
        this.button.setAttribute('aria-busy', isLoading);
        this.button.classList.toggle('loading', isLoading);
        const spinner = this.button.querySelector('.collection-load-more__spinner');
        if (spinner) spinner.classList.toggle('hidden', !isLoading);
      }

      onLoadMore(event) {
        event.preventDefault();
        if (!this.button || this.button.disabled) return;

        const nextUrl = this.button.dataset.url;
        const sectionId = this.dataset.sectionId;
        if (!nextUrl || !sectionId) return;

        this.setLoading(true);

        const fetchUrl = new URL(nextUrl, window.location.origin);
        fetchUrl.searchParams.set('section_id', sectionId);

        fetch(fetchUrl.toString())
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productGrid = document.getElementById('product-grid');
            const newProducts = parsedHTML.querySelectorAll('#product-grid .grid__item');

            if (productGrid && newProducts.length) {
              const currentCount = productGrid.querySelectorAll('.grid__item').length;
              newProducts.forEach((item, index) => {
                const clone = item.cloneNode(true);
                if (clone.classList.contains('scroll-trigger')) {
                  clone.classList.add('scroll-trigger--cancel');
                  clone.style.setProperty('--animation-order', currentCount + index + 1);
                }
                productGrid.appendChild(clone);
              });

              const loadedCount = productGrid.querySelectorAll('.grid__item').length;
              this.dataset.loadedCount = String(loadedCount);
              this.updateStatusText();

              if (typeof initializeScrollAnimationTrigger === 'function') {
                initializeScrollAnimationTrigger(productGrid);
              }
            }

            const newLoadMore = parsedHTML.querySelector('collection-load-more');
            const newButton = newLoadMore?.querySelector('[data-load-more]');

            if (newButton?.dataset.url) {
              this.button.dataset.url = newButton.dataset.url;
            } else {
              this.button.remove();
              this.button = null;
              this.classList.add('collection-load-more--complete');
            }

            const total = Number(this.dataset.total || 0);
            const loadedCount = Number(this.dataset.loadedCount || 0);
            if (total > 0 && loadedCount >= total) {
              this.button?.remove();
              this.button = null;
              this.classList.add('collection-load-more--complete');
            }
          })
          .catch(() => {
            console.error('Failed to load more collection products.');
          })
          .finally(() => {
            this.setLoading(false);
          });
      }
    }
  );
}
